import React, { useMemo, useState } from 'react'
import { Stack } from '@mui/material'
import { Outlet } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import TextField from 'components/global/CUK/TextField'
import MainContent, { TableContent } from 'components-shared'
import { useRegisterBreadcrumbAction } from 'components/AuthenticatedLayout/Header/components/BreadcrumbActions'

import Filters from '../components/Filters'
import Countries from '../components/Filters/Countries'
import userCustomers from './user-customers'
import Table from './Table'
import { useSort } from './store'
import Export from './Export'


export const Customers: React.FC = () => {
  const [date, setDate] = useState<{ start: Date | null, end: Date | null }>({ start: null, end: null })
  const [countries, setCountries] = useState<string[]>([])
  const [verbatim, setVerbatim] = useState<string>('')
  const [sort] = useSort()
  const { t } = useTranslation()
  const exportAction = useMemo(() => (
    <Export
      verbatim={verbatim}
      countries={countries}
      startDate={date.start}
      endDate={date.end}
    />
  ), [countries, date.end, date.start, verbatim])

  useRegisterBreadcrumbAction(exportAction)

  const apiUsers = userCustomers({
    verbatim,
    countries,
    startDate: date.start,
    endDate: date.end,
    sortBy: sort.by,
    sortDirection: sort.direction
  })
  return (
    <Stack flex={2}>
      <Stack direction={'row'} justifyContent={'space-between'} mt={1}>
        <Stack direction={'row'} spacing={1} alignItems={'center'} flex={1}>
          <TextField
            value={verbatim}
            setvalue={newValue => {
              setVerbatim(newValue.toString())
            }}
            width={'300px'}
            type="text"
            input={{
              placeholder: t('statistics.customers.verbatim'),
              starticon: <i className={'fa-light fa-search'} />
            }}
          />
          <Filters
            section={'customers'}
            components={[
              <Countries
                selection={countries}
                onChange={values => {
                  setCountries(values)
                }}
              />,
            ]}
            startDate={date.start}
            endDate={date.end}
            onDateChange={(start, end) => {
              setDate({ start, end })
            }}
          />
        </Stack>
      </Stack>
        <MainContent>
          <TableContent>
            <Table apiUsers={apiUsers} />
          </TableContent>
          <Outlet />
        </MainContent>
    </Stack>
  )
};

export default Customers;